import React, { useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { observer } from 'mobx-react-lite'
import LoadingSpinner from '../../shared/LoadingSpinner.component'
import ContentHtml from '../../content/ContentHtml/ContentHtml.component'
import {
  MDBBtn,
  MDBModalHeader,
  MDBModalTitle,
  MDBModalBody,
  MDBModal,
  MDBModalDialog,
  MDBModalContent,
  MDBCollapse,
} from 'mdb-react-ui-kit'
import UpdatePaymentMethodModalStore from './UpdatePaymentMethodModal.store'

import './UpdatePaymentMethodModal.component.scss'

const UpdatePaymentMethodModal = () => {
  const [isLoading, setIsLoading] = useState(true)
  const history = useHistory()

  useEffect(() => {
    UpdatePaymentMethodModalStore.init()
  }, [])

  const toggleModal = () => {
    UpdatePaymentMethodModalStore.toggleModal()
  }

  return (
    <div className='UpdatePaymentMethodModalComponent'>
      <MDBModal open={UpdatePaymentMethodModalStore.isOpen} tabIndex='-1' onClose={toggleModal}>
        <MDBModalDialog size='lg'>
          <MDBModalContent>
            <MDBModalHeader>
              <MDBModalTitle>Update Payment Method</MDBModalTitle>
              <MDBBtn type='button' className='btn-close' color='none' onClick={toggleModal}></MDBBtn>
            </MDBModalHeader>
            <MDBModalBody className={isLoading ? 'is-loading' : ''}>
              <div className='loading-wrapper'>
                <LoadingSpinner size='md' isActive={true} />
              </div>
              <MDBCollapse open={!isLoading} className='content-modal-wrapper'>
                <ContentHtml
                  contentSlug='billing---update-payment-method'
                  onLoad={contentResponse => {
                    UpdatePaymentMethodModalStore.isOpen && setIsLoading(false)
                  }}
                />
                <br />
                <MDBBtn
                  type='button'
                  color='default'
                  block
                  className='btn btn-info'
                  onClick={() => {
                    toggleModal()
                    history.push('/account-billinginfo')
                  }}
                >
                  OK
                </MDBBtn>
              </MDBCollapse>
            </MDBModalBody>
          </MDBModalContent>
        </MDBModalDialog>
      </MDBModal>
    </div>
  )
}

export default observer(UpdatePaymentMethodModal)
